module.exports = __webpack_public_path__ + "img/aijia-banner.ab6e2144.jpg";